import { useEffect } from "react"
import { useNavigate, useParams } from "react-router-dom"

import { setPassword } from "../modules/auth"

export function SetPassword() {
  const { value } = useParams()
  const navigate = useNavigate()

  useEffect(()=> {
    if (value === undefined) {
      navigate("/account", { replace: true })
      return
    }
    setPassword(value)
    // Full redirect, not router navigation: IS_AUTH / WHEN / password are
    // module-load snapshots and must re-evaluate with the new password.
    window.location.replace("/account")
  }, [navigate, value])

  return <div>Loading…</div>
}